import React, { Fragment, useState } from 'react'
import { turboRequest } from '../../../../helpers/turbo_helper'
import './style.scss'

import TypeaheadInput from 'components/TypeaheadInput'

const SelectCustomer = props => {
  const [state, setState] = useState(() => {
    return {
      ...props
    }
  })

  const onChange = value => {
    const selected = state.options.find(item => item.value === value)

    setState(() => ({ ...props, selected: selected ? selected.value : null }))

    if (selected) {
      var url = new URL(state.url)
      var urlParams = new URLSearchParams(url.search)
      urlParams.append('customer_id', selected.value)

      turboRequest(`${url.pathname}?${urlParams}`)
    }
  }

  return (
    <Fragment>
      <div className='input required' id='select_person_input'>
        <div className='org-typeahead'>
          <TypeaheadInput {...state} filterBy={['client', 'client_email']} onChange={onChange} />
        </div>
      </div>
    </Fragment>
  )
}

export default SelectCustomer
